import React from 'react';
import { FormikProps } from 'formik';
import PersonalInfo from '@/components/PersonalInfo';
import Insurances from '@/components/Insurances';
import Receipt from '@/components/Receipt';
import { NjffValues, NUMBER_OF_PARTNER_FORM_PAGES, Page, PersonalInfoValues } from '@/data/Types';

const FormContent = ({
    formik,
    setPage,
    page,
    pages,
    sentError,
    removeSentError,
    withOptionalComment = false,
}: {
    formik: FormikProps<PersonalInfoValues> | FormikProps<NjffValues>;
    setPage: (page: Page) => void;
    page: Page;
    pages: number;
    sentError: boolean;
    removeSentError: () => void;
    withOptionalComment?: boolean;
}) => {
    if (page === 'personalInfo') {
        return (
            <PersonalInfo
                formik={formik as FormikProps<PersonalInfoValues>}
                setPage={setPage}
                shortenWizard={pages === NUMBER_OF_PARTNER_FORM_PAGES}
                withOptionalComment={withOptionalComment}
                sentError={sentError}
            />
        );
    }
    if (page === 'insurances') {
        return (
            <Insurances
                formik={formik as FormikProps<NjffValues>}
                setPage={setPage}
                sentError={sentError}
                removeSentError={removeSentError}
            />
        );
    }
    return <Receipt />;
};

export default FormContent;
